import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Button, Label, PopoverBody } from 'reactstrap';
import * as statisticsConst from '../../../constants/statisticsTypes';
import Select from 'react-select';
import { DateTimePicker } from 'react-widgets';
import { ANDROID_PLATFORM, DRAUGIEM_PLATFORM, DWEB_PLATFORM, FACEBOOK_PLATFORM, INBOX_PLATFORM, IOS_PLATFORM, MWEB_PLATFORM, SCREENS } from '../../../constants/constants';
import { UncontrolledPopover } from 'reactstrap/lib';

const customStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: '1px dotted pink',
      color: state.isSelected ? 'black' : 'black',
      padding: 10,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
      return { ...provided, opacity, transition };
    }
};

const PageViews = ({ fetchStatisticPageViews, statisticsPageViews }) => {
    const [selectedViewsTypeOption, setSelectedViewsTypeOption] = useState(statisticsConst.STATISTICS_VIEWS_TYPE[0]);
    const [selectedEnvOption, setSelectedEnvOption] = useState(statisticsConst.STATISTICS_ENV_MODE[0]);

    const [date, setDate] = useState(new Date());

    useEffect(() => {
        fetchStatisticPageViews(date, selectedEnvOption);
    }, []);

    useEffect(() => {
        fetchStatisticPageViews(date, selectedEnvOption);
    }, [date, selectedEnvOption]);

    const getScreenViews = useCallback((screenValue, gameEnv, design) => {
        if (selectedViewsTypeOption.value === 'unique') {
            return Object.keys(
                statisticsPageViews?.[gameEnv]?.[design]?.[screenValue] || {}
            ).length;
        }

        return Object.values(
            statisticsPageViews?.[gameEnv]?.[design]?.[screenValue] || {}
        ).reduce((a, b) => a + b, 0);
    }, [
        selectedViewsTypeOption.value,
        statisticsPageViews
    ]);

    const getScreenViewsAllGameEnvs = useCallback((screenValue, design) => {
        return (
            getScreenViews(screenValue, DWEB_PLATFORM, design) +
            getScreenViews(screenValue, MWEB_PLATFORM, design) +
            getScreenViews(screenValue, DRAUGIEM_PLATFORM, design) +
            getScreenViews(screenValue, FACEBOOK_PLATFORM, design) +
            getScreenViews(screenValue, INBOX_PLATFORM, design) +
            getScreenViews(screenValue, IOS_PLATFORM, design) +
            getScreenViews(screenValue, ANDROID_PLATFORM, design)
        );
    }, [getScreenViews]);


    const getScreenViewsRowSum = useCallback((screens, title) => {
        return (
            <tr>
                <td style={{background: 'rgba(255,255,255, 0.15)'}}>{title}</td>
                <td>
                    {screens.reduce((total, screen) => {
                        return (
                            total
                            + getScreenViewsAllGameEnvs(screen.value, 'oldDesign')
                            + getScreenViewsAllGameEnvs(screen.value, 'newDesign')
                        );
                    }, 0)}
                </td>
                <td style={{background: 'rgba(255,255,255, 0.15)'}}></td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, DWEB_PLATFORM, 'oldDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, MWEB_PLATFORM, 'oldDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, DRAUGIEM_PLATFORM, 'oldDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, FACEBOOK_PLATFORM, 'oldDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, INBOX_PLATFORM, 'oldDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, IOS_PLATFORM, 'oldDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, ANDROID_PLATFORM, 'oldDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViewsAllGameEnvs(screen.value, 'oldDesign');
                    }, 0)}
                </td>
                <td style={{background: 'rgba(255,255,255, 0.15)'}}></td>
                
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, DWEB_PLATFORM, 'newDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, MWEB_PLATFORM, 'newDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, DRAUGIEM_PLATFORM, 'newDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, FACEBOOK_PLATFORM, 'newDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, INBOX_PLATFORM, 'newDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, IOS_PLATFORM, 'newDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViews(screen.value, ANDROID_PLATFORM, 'newDesign');
                    }, 0)}
                </td>
                <td>
                    {screens.reduce((total, screen) => {
                        return total + getScreenViewsAllGameEnvs(screen.value, 'newDesign');
                    }, 0)}
                </td>
            </tr>
        );
    }, [getScreenViews]);


    const getScreenViewsRow = (screen, disableItems) => {
        return (
            <tr>
                <td style={{background: 'rgba(255,255,255, 0.15)'}}>{screen.label}</td>
                <td>
                    {
                        getScreenViewsAllGameEnvs(screen.value, 'oldDesign')
                        + getScreenViewsAllGameEnvs(screen.value, 'newDesign')
                    }
                </td>
                <td style={{background: 'rgba(255,255,255, 0.15)'}}></td>
                {!disableItems?.includes('oldDesign') ? (
                    <>
                        <td>{getScreenViews(screen.value, DWEB_PLATFORM, 'oldDesign')}</td>
                        <td>{getScreenViews(screen.value, MWEB_PLATFORM, 'oldDesign')}</td>
                        <td>{getScreenViews(screen.value, DRAUGIEM_PLATFORM, 'oldDesign')}</td>
                        <td>{getScreenViews(screen.value, FACEBOOK_PLATFORM, 'oldDesign')}</td>
                        <td>{getScreenViews(screen.value, INBOX_PLATFORM, 'oldDesign')}</td>
                        <td>{getScreenViews(screen.value, IOS_PLATFORM, 'oldDesign')}</td>
                        <td>{getScreenViews(screen.value, ANDROID_PLATFORM, 'oldDesign')}</td>
                        <td>{getScreenViewsAllGameEnvs(screen.value, 'oldDesign')}</td>
                    </>
                ) : (
                    <>
                        {Array.from({ length: 8 }).map((_, index) => (
                            <td key={index} style={{ background: 'rgba(255,255,255, 0.15)', height: 20 }}/>
                        ))}
                    </>
                )}


                <td style={{background: 'rgba(255,255,255, 0.15)'}}></td>
                <td>{getScreenViews(screen.value, DWEB_PLATFORM, 'newDesign')}</td>
                <td>{getScreenViews(screen.value, MWEB_PLATFORM, 'newDesign')}</td>
                <td>{getScreenViews(screen.value, DRAUGIEM_PLATFORM, 'newDesign')}</td>
                <td>{getScreenViews(screen.value, FACEBOOK_PLATFORM, 'newDesign')}</td>
                <td>{getScreenViews(screen.value, INBOX_PLATFORM, 'newDesign')}</td>
                <td>{getScreenViews(screen.value, IOS_PLATFORM, 'newDesign')}</td>
                <td>{getScreenViews(screen.value, ANDROID_PLATFORM, 'newDesign')}</td>
                <td>{getScreenViewsAllGameEnvs(screen.value, 'newDesign')}</td>
            </tr>
        );
    }

    const fillerRow = () => {
        return (
            <tr>
                {Array.from({ length: 20 }).map((_, index) => (
                    <td key={index} style={{ background: 'rgba(255,255,255, 0.25)', height: 20 }}/>
                ))}
            </tr>
        );
    }

    return (
        <Fragment>
            <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-page-views">
                <PopoverBody className="popover-body">
                    Total and unique page views for each date
                </PopoverBody>
            </UncontrolledPopover>
            <div className="admin-page-content">
                <h2>
                    Page Views
                    <Button className="admin-help-button" id="admin-help-button-page-views">
                        ?
                    </Button>
                </h2>
                
                <div className="mb-3">
                    <div style={{width: '15%', display: 'inline-block', padding: 3}}>
                        <Label>
                            Date
                        </Label>
                        <DateTimePicker
                            format="DD.MM.YYYY"
                            culture="en"
                            onChange={(val) => setDate(val)}
                            value={date}
                            // defaultCurrentDate={startCalendarDate}
                            // currentDate={startCalendarDate}
                            // onCurrentDateChange={(date) => this.changeStartCalendarDate(date)}
                            //defaultValue={new Date(Date.now() - 24 * 60 * 60 * 1000)}
                            time={false}
                        />
                    </div>

                    <div style={{width: '15%', display: 'inline-block', padding: 3}}>
                        <Label>
                            Views Type
                        </Label>
                        <Select closeMenuOnSelect={true} options={statisticsConst.STATISTICS_VIEWS_TYPE} styles={customStyles} value={selectedViewsTypeOption} onChange={(opt) => setSelectedViewsTypeOption(opt)} />
                    </div>

                    <div style={{width: '15%', display: 'inline-block', padding: 3}}>
                        <Label>
                            Environment
                        </Label>
                        <Select closeMenuOnSelect={true} options={statisticsConst.STATISTICS_ENV_MODE} styles={customStyles} value={selectedEnvOption} onChange={(opt) => setSelectedEnvOption(opt)} />
                    </div>
                </div>

                <div className="admin-statistics-table-page-views-wrapper">
                    <table className="admin-statistics-table-page-views">
                        <thead>
                            <tr style={{background: 'rgba(255,255,255, 0.25)'}}>
                                <th style={{background: 'none'}}></th>
                                <th>Old/New Design</th>
                                <th></th>
                                <th colspan="8">Old Design</th>
                                <th></th>
                                <th colspan="8">New Design</th>
                            </tr>
                            <tr style={{background: 'rgba(255,255,255, 0.15)'}}>
                                <th style={{background: 'none'}}></th>
                                <th>Total</th>
                                <th></th>
                                <th>dWeb</th>
                                <th>mWeb</th>
                                <th>Draugiem</th>
                                <th>Facebook</th>
                                <th>Inbox</th>
                                <th>iOS</th>
                                <th>Android</th>
                                <th>Total</th>
                                <th></th>
                                <th>dWeb</th>
                                <th>mWeb</th>
                                <th>Draugiem</th>
                                <th>Facebook</th>
                                <th>Inbox</th>
                                <th>iOS</th>
                                <th>Android</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getScreenViewsRowSum([
                                SCREENS.LANDING.HOME,
                                SCREENS.LANDING.HELP_PAGE,
                                SCREENS.LANDING.BLOG,
                                SCREENS.LANDING.CONTACTS,
                                SCREENS.LANDING.VERSION_HISTORY_MODAL,
                                SCREENS.LANDING.VERSION_HISTORY,
                                SCREENS.LANDING.TERMS_OF_USE,
                            ], 'Landing - Total')}
                            {getScreenViewsRow(SCREENS.LANDING.HOME)}
                            {getScreenViewsRow(SCREENS.LANDING.HELP_PAGE)}
                            {getScreenViewsRow(SCREENS.LANDING.BLOG)}
                            {getScreenViewsRow(SCREENS.LANDING.CONTACTS)}
                            {getScreenViewsRow(SCREENS.LANDING.VERSION_HISTORY_MODAL, ['oldDesign'])}
                            {getScreenViewsRow(SCREENS.LANDING.VERSION_HISTORY, ['oldDesign'])}
                            {getScreenViewsRow(SCREENS.LANDING.TERMS_OF_USE)}
                            {fillerRow()}

                            {getScreenViewsRowSum([
                                SCREENS.LOGIN.LOGIN,
                                SCREENS.LOGIN.SIGN_UP,
                                SCREENS.LOGIN.RESET_PASSWORD,
                            ], 'Login - Total')}
                            {getScreenViewsRow(SCREENS.LOGIN.LOGIN)}
                            {getScreenViewsRow(SCREENS.LOGIN.SIGN_UP)}
                            {getScreenViewsRow(SCREENS.LOGIN.RESET_PASSWORD)}
                            {fillerRow()}

                            {getScreenViewsRow(SCREENS.LOADING)}
                            {fillerRow()}

                            {getScreenViewsRowSum([
                                SCREENS.ROOMS.ROOMS,
                                SCREENS.ROOMS.CREATE,
                                SCREENS.ROOMS.FILTER,
                                SCREENS.ROOMS.LEGENDS,
                            ], 'Rooms - Total')}
                            {getScreenViewsRow(SCREENS.ROOMS.ROOMS)}
                            {getScreenViewsRow(SCREENS.ROOMS.CREATE)}
                            {getScreenViewsRow(SCREENS.ROOMS.FILTER)}
                            {getScreenViewsRow(SCREENS.ROOMS.LEGENDS)}
                            {fillerRow()}

                            {getScreenViewsRowSum([
                                SCREENS.TOP.ALL_TIME,
                                SCREENS.TOP.TODAY,
                                SCREENS.TOP.THIS_WEEK,
                                SCREENS.TOP.THIS_MONTH,
                                SCREENS.TOP.THIS_YEAR,
                            ], 'Top - All Tabs')}
                            {getScreenViewsRow(SCREENS.TOP.ALL_TIME)}
                            {getScreenViewsRow(SCREENS.TOP.TODAY)}
                            {getScreenViewsRow(SCREENS.TOP.THIS_WEEK)}
                            {getScreenViewsRow(SCREENS.TOP.THIS_MONTH)}
                            {getScreenViewsRow(SCREENS.TOP.THIS_YEAR)}
                            {getScreenViewsRow(SCREENS.TOP.MILLIONAIRES)}
                            {getScreenViewsRow(SCREENS.TOP.FILTERS)}
                            {fillerRow()}

                            {getScreenViewsRowSum([
                                SCREENS.POWER_RANKINGS.BEST_RATING,
                                SCREENS.POWER_RANKINGS.BEST_POINTS,
                                SCREENS.POWER_RANKINGS.BEST_COINS,
                                SCREENS.POWER_RANKINGS.WINS_COUNT,
                                SCREENS.POWER_RANKINGS.WIN_PERCENTAGE,
                                SCREENS.POWER_RANKINGS.WORST_RATING,
                                SCREENS.POWER_RANKINGS.WORST_POINTS,
                                SCREENS.POWER_RANKINGS.WORST_COINS,
                                SCREENS.POWER_RANKINGS.LOSS_COUNT,
                                SCREENS.POWER_RANKINGS.LOSS_PERCENTAGE,
                            ], 'Power Rankings - All Tabs')}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.BEST_RATING)}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.BEST_POINTS)}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.BEST_COINS)}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.WINS_COUNT)}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.WIN_PERCENTAGE)}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.WORST_RATING)}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.WORST_POINTS)}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.WORST_COINS)}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.LOSS_COUNT)}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.LOSS_PERCENTAGE)}
                            {getScreenViewsRow(SCREENS.POWER_RANKINGS.INFO)}
                            {fillerRow()}

                            {getScreenViewsRowSum([
                                SCREENS.MY_INFO.MY_INFO,
                                SCREENS.MY_INFO.MY_FRIENDS,
                                SCREENS.MY_INFO.IGNORED,
                                SCREENS.MY_INFO.ACHIEVEMENTS,
                                SCREENS.MY_INFO.RESULTS,
                                SCREENS.MY_INFO.WEEKLY_STATISTICS,
                                SCREENS.MY_INFO.GAME_LOGS,
                            ], 'My Info - All Tabs')}
                            {getScreenViewsRow(SCREENS.MY_INFO.MY_INFO)}
                            {getScreenViewsRow(SCREENS.MY_INFO.MY_FRIENDS)}
                            {getScreenViewsRow(SCREENS.MY_INFO.IGNORED)}
                            {getScreenViewsRow(SCREENS.MY_INFO.ACHIEVEMENTS)}
                            {getScreenViewsRow(SCREENS.MY_INFO.RESULTS)}
                            {getScreenViewsRow(SCREENS.MY_INFO.WEEKLY_STATISTICS)}
                            {getScreenViewsRow(SCREENS.MY_INFO.GAME_LOGS)}
                            {getScreenViewsRow(SCREENS.MY_INFO.RATING_INFO)}
                            {getScreenViewsRow(SCREENS.MY_INFO.STATISTICS_INFO)}
                            {getScreenViewsRow(SCREENS.MY_INFO.GAME_INFO)}
                            {fillerRow()}

                            {getScreenViewsRowSum([
                                SCREENS.TOURNAMENTS.ACTIVE,
                                SCREENS.TOURNAMENTS.FUTURE,
                                SCREENS.TOURNAMENTS.PAST,
                            ], 'Tournaments - All Tabs')}
                            {getScreenViewsRow(SCREENS.TOURNAMENTS.ACTIVE)}
                            {getScreenViewsRow(SCREENS.TOURNAMENTS.FUTURE)}
                            {getScreenViewsRow(SCREENS.TOURNAMENTS.PAST)}
                            {getScreenViewsRow(SCREENS.TOURNAMENTS.TUTORIAL)}
                            {getScreenViewsRow(SCREENS.TOURNAMENTS.INFO)}
                            {getScreenViewsRow(SCREENS.TOURNAMENTS.RESULTS)}
                            {fillerRow()}

                            {getScreenViewsRow(SCREENS.LUCKY_WHEEL.LUCKY_WHEEL)}
                            {getScreenViewsRow(SCREENS.LUCKY_WHEEL.HISTORY)}
                            {fillerRow()}

                            {getScreenViewsRow(SCREENS.SETTINGS)}
                            {getScreenViewsRow(SCREENS.MENU)}
                            {fillerRow()}

                            {getScreenViewsRowSum([
                                SCREENS.SHOP.MONEY_PACKS,
                                SCREENS.SHOP.PREMIUM_PACKS,
                                SCREENS.SHOP.TOURNAMENT_TICKETS,
                                SCREENS.SHOP.TRANSACTION_HISTORY,
                                SCREENS.SHOP.REDEEM_CODE,
                            ], 'Shop - All Tabs')}
                            {getScreenViewsRow(SCREENS.SHOP.MONEY_PACKS)}
                            {getScreenViewsRow(SCREENS.SHOP.PREMIUM_PACKS)}
                            {getScreenViewsRow(SCREENS.SHOP.TOURNAMENT_TICKETS)}
                            {getScreenViewsRow(SCREENS.SHOP.TRANSACTION_HISTORY)}
                            {getScreenViewsRow(SCREENS.SHOP.REDEEM_CODE)}
                            {fillerRow()}

                            {getScreenViewsRow(SCREENS.PROFILE)}
                            {getScreenViewsRow(SCREENS.TECHNICAL_SUPPORT)}
                            {getScreenViewsRow(SCREENS.GAME_GUIDE)}
                            {getScreenViewsRow(SCREENS.GAME_HELP)}
                            {getScreenViewsRow(SCREENS.ABOUT)}
                            {getScreenViewsRow(SCREENS.TERMS_OF_USE)}
                            {fillerRow()}

                            {getScreenViewsRow(SCREENS.MONEY_HISTORY)}
                            {getScreenViewsRow(SCREENS.POINTS_HISTORY)}
                            {fillerRow()}

                            {getScreenViewsRowSum([
                                SCREENS.ACTIVE_ROOM.REPORT_PLAYER,
                                SCREENS.ACTIVE_ROOM.PLAYER_INFO,
                                SCREENS.ACTIVE_ROOM.GIFTS,
                                SCREENS.ACTIVE_ROOM.SELECT_ACTION,
                                SCREENS.ACTIVE_ROOM.EVERYONE_PASSED,
                                SCREENS.ACTIVE_ROOM.AUTO_PLAY,
                                SCREENS.ACTIVE_ROOM.EXIT,
                                SCREENS.ACTIVE_ROOM.GAME_RESULT,
                                SCREENS.ACTIVE_ROOM.RESULTS,
                                SCREENS.ACTIVE_ROOM.GAME_INFO,
                            ], 'Active Room - Total')}
                            {getScreenViewsRow(SCREENS.ACTIVE_ROOM.REPORT_PLAYER)}
                            {getScreenViewsRow(SCREENS.ACTIVE_ROOM.PLAYER_INFO)}
                            {getScreenViewsRow(SCREENS.ACTIVE_ROOM.GIFTS)}
                            {getScreenViewsRow(SCREENS.ACTIVE_ROOM.SELECT_ACTION)}
                            {getScreenViewsRow(SCREENS.ACTIVE_ROOM.EVERYONE_PASSED)}
                            {getScreenViewsRow(SCREENS.ACTIVE_ROOM.AUTO_PLAY)}
                            {getScreenViewsRow(SCREENS.ACTIVE_ROOM.EXIT)}
                            {getScreenViewsRow(SCREENS.ACTIVE_ROOM.GAME_RESULT)}
                            {getScreenViewsRow(SCREENS.ACTIVE_ROOM.RESULTS)}
                            {getScreenViewsRow(SCREENS.ACTIVE_ROOM.GAME_INFO)}

                            {fillerRow()}
                            {getScreenViewsRowSum([
                                SCREENS.LANDING.HOME,
                                SCREENS.LANDING.HELP_PAGE,
                                SCREENS.LANDING.BLOG,
                                SCREENS.LANDING.CONTACTS,
                                SCREENS.LANDING.VERSION_HISTORY_MODAL,
                                SCREENS.LANDING.VERSION_HISTORY,
                                SCREENS.LANDING.TERMS_OF_USE,
                                SCREENS.LOGIN.LOGIN,
                                SCREENS.LOGIN.SIGN_UP,
                                SCREENS.LOGIN.RESET_PASSWORD,
                                SCREENS.LOADING,
                                SCREENS.ROOMS.ROOMS,
                                SCREENS.ROOMS.CREATE,
                                SCREENS.ROOMS.FILTER,
                                SCREENS.ROOMS.LEGENDS,
                                SCREENS.TOP.ALL_TIME,
                                SCREENS.TOP.TODAY,
                                SCREENS.TOP.THIS_WEEK,
                                SCREENS.TOP.THIS_MONTH,
                                SCREENS.TOP.THIS_YEAR,
                                SCREENS.TOP.MILLIONAIRES,
                                SCREENS.TOP.FILTERS,
                                SCREENS.POWER_RANKINGS.BEST_RATING,
                                SCREENS.POWER_RANKINGS.BEST_POINTS,
                                SCREENS.POWER_RANKINGS.BEST_COINS,
                                SCREENS.POWER_RANKINGS.WINS_COUNT,
                                SCREENS.POWER_RANKINGS.WIN_PERCENTAGE,
                                SCREENS.POWER_RANKINGS.WORST_RATING,
                                SCREENS.POWER_RANKINGS.WORST_POINTS,
                                SCREENS.POWER_RANKINGS.WORST_COINS,
                                SCREENS.POWER_RANKINGS.LOSS_COUNT,
                                SCREENS.POWER_RANKINGS.LOSS_PERCENTAGE,
                                SCREENS.POWER_RANKINGS.INFO,
                                SCREENS.MY_INFO.MY_INFO,
                                SCREENS.MY_INFO.MY_FRIENDS,
                                SCREENS.MY_INFO.IGNORED,
                                SCREENS.MY_INFO.ACHIEVEMENTS,
                                SCREENS.MY_INFO.RESULTS,
                                SCREENS.MY_INFO.WEEKLY_STATISTICS,
                                SCREENS.MY_INFO.GAME_LOGS,
                                SCREENS.MY_INFO.RATING_INFO,
                                SCREENS.MY_INFO.STATISTICS_INFO,
                                SCREENS.MY_INFO.GAME_INFO,
                                SCREENS.TOURNAMENTS.ACTIVE,
                                SCREENS.TOURNAMENTS.FUTURE,
                                SCREENS.TOURNAMENTS.PAST,
                                SCREENS.TOURNAMENTS.TUTORIAL,
                                SCREENS.TOURNAMENTS.INFO,
                                SCREENS.TOURNAMENTS.RESULTS,
                                SCREENS.LUCKY_WHEEL.LUCKY_WHEEL,
                                SCREENS.LUCKY_WHEEL.HISTORY,
                                SCREENS.SETTINGS,
                                SCREENS.MENU,
                                SCREENS.SHOP.MONEY_PACKS,
                                SCREENS.SHOP.PREMIUM_PACKS,
                                SCREENS.SHOP.TOURNAMENT_TICKETS,
                                SCREENS.SHOP.TRANSACTION_HISTORY,
                                SCREENS.SHOP.REDEEM_CODE,
                                SCREENS.PROFILE,
                                SCREENS.TECHNICAL_SUPPORT,
                                SCREENS.GAME_GUIDE,
                                SCREENS.GAME_HELP,
                                SCREENS.ABOUT,
                                SCREENS.TERMS_OF_USE,
                                SCREENS.ACTIVE_ROOM.REPORT_PLAYER,
                                SCREENS.ACTIVE_ROOM.PLAYER_INFO,
                                SCREENS.ACTIVE_ROOM.GIFTS,
                                SCREENS.ACTIVE_ROOM.SELECT_ACTION,
                                SCREENS.ACTIVE_ROOM.EVERYONE_PASSED,
                                SCREENS.ACTIVE_ROOM.AUTO_PLAY,
                                SCREENS.ACTIVE_ROOM.EXIT,
                                SCREENS.ACTIVE_ROOM.GAME_RESULT,
                                SCREENS.ACTIVE_ROOM.RESULTS,
                                SCREENS.ACTIVE_ROOM.GAME_INFO,
                            ], 'Total')}
                        </tbody>
                    </table>
                </div>
            </div>
            

                        {/* <td>Landing</td>
                        <td>Landing - Help</td>
                        <td>Landing - Blog</td>
                        <td>Landing - Contacts</td>
                        <td>Landing - Version History dialog</td>
                        <td>Landing - Version History</td>
                        <td>Landing - Terms of Use</td> */}
        </Fragment>
    );
  };
  
export default PageViews;